// extracted by mini-css-extract-plugin
export var indeterminate = "_3q-6";
export var md = "_3q-5";
export var semantic = "_3q-7";
export var sm = "_3q-4";
export var text = "_3q-8";
export var toggleControl = "_3q-0";
export var toggleInput = "_3q-1";
export var toggleSwitch = "_3q-2";
export var xs = "_3q-3";